import { useParams, Navigate } from "react-router-dom";

// This handles the edge case where someone visits an old
// numeric ID URL like /product/48 — we just send them home
// since we no longer look up by ID on the public side.
// In practice this should rarely happen after the slug migration.

export default function ProductRedirect() {
  const { id } = useParams<{ id: string }>();

  // If it looks like a numeric ID, redirect home
  // If it somehow got here with a slug, that's handled by the main route
  if (id && /^\d+$/.test(id)) {
    return <Navigate to="/" replace />;
  }

  return <Navigate to="/" replace />;
}
